import { CssVarsProvider, useColorScheme } from "@mui/joy";
import { LicenseInfo } from "@mui/x-data-grid-pro";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { useEffect } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { AppConfig } from "./environement";
import { appTheme } from "./hooks/config/themeConfig";
import NerdApp from "./hooks/nerdApp/nerdApp";
import "./i18n";
import "./index.css";
import { store } from "./redux/store";
import AskQuestion from "./hooks/askQuestion/askQuestion";

document.title = "Rhapsody";
// const favIcon = document.getElementById("favicon");
// if (favIcon !== null && favIcon instanceof HTMLLinkElement)
//   favIcon.href = AppConfig.app.favicon || "";

Sentry.init({
  dsn: "https://cdf242cf4dc44566b6dc88237793a769@o1058683.ingest.sentry.io/6046515",
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

//Mui X Pro License Key
//Mui X License Key
LicenseInfo.setLicenseKey(
  "32bbc944f049b119837b98aac291a661Tz0xMTk2NjAsRT0xNzkwNTUzNTk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9UTEtMjAyNixRPTEsQVQ9bXVsdGksS1Y9Mg=="
);

const container = document.getElementById("root");

/**
 * Forces light mode app-wide — dark mode is disabled on the web. Overrides any
 * previously persisted "dark" preference.
 *
 * @returns {null} nothing
 */
function ForceLightMode(): null {
  const { setMode } = useColorScheme();
  useEffect(() => {
    setMode("light");
  }, [setMode]);
  return null;
}

if (container != null) {
  const root = createRoot(container);
  root.render(
    // <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <CssVarsProvider theme={appTheme} defaultMode="light">
          <ForceLightMode />
          <AskQuestion>
            <NerdApp />
          </AskQuestion>
        </CssVarsProvider>
      </Provider>
    </BrowserRouter>
    // </React.StrictMode>
  );
}
